<label class="flex gap-16 items-center mt-16 cursor-pointer">
    <input type="checkbox" class="mailing-unsubscribe__checkbox">
    <span class="text-14 !font-normal leading-[1.4]">{{T "components.voyo_mailing_unsubscribe.checkboxLabel" }}</span>
</label>
